import type { MisconceptionDefinition } from '../types'

export const GET_BREUKEN: MisconceptionDefinition[] = [
  {
    id: 'get.fraction-whole-comparison',
    label: 'Breuk als geheel getal vergeleken',
    module: 'Getalbegrip',
    description:
      'Leerling vergelijkt teller en noemer apart i.p.v. de breukwaarde.',
    typicalFamilies: ['GET-BREUK-BASIS', 'GET-VERGELIJK'],
  },
  {
    id: 'get.breuk-deel-niet-omdraaien',
    label: 'Breuk delen zonder om te draaien',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt de breuken direct i.p.v. eerst de tweede breuk om te draaien.',
    typicalFamilies: ['GET-BREUK-DEEL'],
  },
  {
    id: 'get.breuk-deel-alleen-teller',
    label: 'Alleen teller of noemer omgedraaid',
    module: 'Getalbegrip',
    description:
      'Leerling draait alleen de teller of alleen de noemer om i.p.v. de hele tweede breuk.',
    typicalFamilies: ['GET-BREUK-DEEL'],
  },
  {
    id: 'get.breuk-deel-noemer-als-antwoord',
    label: 'Noemer of teller direct als antwoord',
    module: 'Getalbegrip',
    description:
      'Leerling neemt de noemer (of teller) van een van de breuken direct als antwoord op een delingsvraag.',
    typicalFamilies: ['GET-BREUK-DEEL'],
  },
  {
    id: 'get.breuk-deel-omkering-vergeten',
    label: 'Omkering vergeten in tweede stap',
    module: 'Getalbegrip',
    description:
      'Leerling neemt het omgekeerde maar vergeet vervolgens te vermenigvuldigen — geeft het omgekeerde zelf als antwoord.',
    typicalFamilies: ['GET-BREUK-DEEL'],
  },
  {
    id: 'get.breuk-deel-resultaat-omkeren',
    label: 'Eindresultaat omgekeerd geschreven',
    module: 'Getalbegrip',
    description:
      'Leerling rekent correct maar wisselt teller en noemer in het eindantwoord (b.v. ½ i.p.v. 2).',
    typicalFamilies: ['GET-BREUK-DEEL'],
  },
  {
    id: 'get.fraction-count-error',
    label: 'Verkeerd aantal stukken geteld',
    module: 'Getalbegrip',
    description:
      'Leerling telt te veel of te weinig stukken bij het bepalen van de teller (b.v. 2 i.p.v. 3 gekleurde stukken).',
    typicalFamilies: ['GET-BREUK-BASIS', 'GET-BREUK-RASTER', 'GET-BREUK-LEZEN'],
  },
  {
    id: 'get.fraction-teller-noemer-swap',
    label: 'Teller en noemer verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling schrijft de noemer als teller (b.v. ⁴⁄₃ i.p.v. ³⁄₄).',
    typicalFamilies: ['GET-BREUK-BASIS', 'GET-BREUK-LEZEN', 'GET-BREUK-RASTER'],
  },
  {
    id: 'get.fraction-whole-confusion',
    label: 'Breuk als geheel getal gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling leest de teller of noemer los als geheel getal (b.v. ¾ als 3 of 4).',
    typicalFamilies: ['GET-BREUK-BASIS', 'GET-BREUK-LEZEN'],
  },
  {
    id: 'get.fraction-remaining-vs-eaten',
    label: 'Overgebleven vs. opgegeten verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling kiest het overgebleven deel als antwoord terwijl naar het opgegeten/gebruikte deel gevraagd wordt (of omgekeerd).',
    typicalFamilies: ['GET-BREUK-BASIS'],
  },
  {
    id: 'get.fraction-wrong-total',
    label: 'Verkeerd totaal als noemer',
    module: 'Getalbegrip',
    description:
      'Leerling neemt een verkeerd aantal als totaal (b.v. alleen de rest, of teller + 1) als noemer.',
    typicalFamilies: ['GET-BREUK-BASIS', 'GET-BREUK-RASTER'],
  },
  {
    id: 'get.fraction-compare-wrong-pick',
    label: 'Kleinere breuk als grootste gekozen',
    module: 'Getalbegrip',
    description:
      'Leerling kiest de breuk met de grootste noemer (of teller) als grootste, zonder de waarde te berekenen.',
    typicalFamilies: ['GET-VERGELIJK', 'GET-VERGELIJK-JUDGE'],
  },
  {
    id: 'get.fraction-compare-equal-error',
    label: 'Ongelijke breuken als gelijk beoordeeld',
    module: 'Getalbegrip',
    description:
      'Leerling concludeert dat twee breuken gelijk zijn op basis van teller/noemer-patronen i.p.v. waarde.',
    typicalFamilies: ['GET-VERGELIJK', 'GET-VERGELIJK-JUDGE'],
  },
  {
    id: 'get.fraction-compare-give-up',
    label: 'Geeft op bij ongelijknamige breuken',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat ongelijknamige breuken niet vergelijkbaar zijn en kiest willekeurig of "gelijk".',
    typicalFamilies: ['GET-VERGELIJK', 'GET-VERGELIJK-JUDGE'],
  },
  {
    id: 'get.kwart-helft-verward',
    label: 'Kwart en helft verwisseld',
    module: 'Getalbegrip',
    description: 'Leerling verwart 25% (¼) met 50% (½).',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.kwart-tiende-verward',
    label: 'Kwart en tiende verwisseld',
    module: 'Getalbegrip',
    description: 'Leerling verwart 25% (¼) met 10% (1/10).',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.deel-rest-verward',
    label: 'Deel en rest verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling kiest het complement (b.v. ¾ i.p.v. ¼) door verkeerd af te lezen welke kant gevraagd wordt.',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-BREUK-BASIS'],
  },
  {
    id: 'get.deel-helft-verward',
    label: 'Willekeurig deel als helft gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling neemt een willekeurig deel/fractie aan als de helft (50%).',
    typicalFamilies: ['GET-PROC-BASIS'],
  },
  {
    id: 'get.driekwart-kwart-verward',
    label: 'Driekwart en kwart verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling verwart 75% (¾) met 25% (¼), vaak omdat naar de rest gekeken wordt.',
    typicalFamilies: ['GET-PROC-BASIS'],
  },
  {
    id: 'get.breuk-keer-optellen-tnoemer',
    label: 'Teller én noemer opgeteld i.p.v. vermenigvuldigd',
    module: 'Getalbegrip',
    description:
      'Leerling telt zowel teller als noemer op bij breuken vermenigvuldigen (b.v. ½ × ⅓ → 2/5).',
    typicalFamilies: ['GET-BREUK-KEER'],
  },
  {
    id: 'get.breuk-keer-teller-optellen',
    label: 'Teller opgeteld i.p.v. vermenigvuldigd',
    module: 'Getalbegrip',
    description:
      'Leerling telt de tellers op maar vermenigvuldigt de noemers (b.v. ½ × ⅓ → 2/6).',
    typicalFamilies: ['GET-BREUK-KEER'],
  },
  {
    id: 'get.breuk-keer-noemer-optellen',
    label: 'Noemer opgeteld i.p.v. vermenigvuldigd',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt de tellers maar telt de noemers op (b.v. ½ × ⅓ → 1/5).',
    typicalFamilies: ['GET-BREUK-KEER'],
  },
  {
    id: 'get.breuk-min-noemers-optellen',
    label: 'Noemers opgeteld bij aftrekken van gelijknamige breuken',
    module: 'Getalbegrip',
    description:
      'Leerling telt de noemers op (bv. 4 + 4 = 8) bij het aftrekken van gelijknamige breuken, terwijl de noemer hetzelfde moet blijven.',
    typicalFamilies: ['GET-BREUK-GEL-MIN', 'GET-BREUK-GEL-PLUS'],
  },
  {
    id: 'get.breuk-min-tellers-optellen',
    label: 'Tellers opgeteld in plaats van afgetrokken',
    module: 'Getalbegrip',
    description:
      'Leerling telt de tellers op in plaats van ze af te trekken, ondanks het minteken.',
    typicalFamilies: ['GET-BREUK-GEL-MIN'],
  },
  {
    id: 'get.breuk-min-noemers-aftrekken',
    label: 'Noemers ook afgetrokken bij gelijknamige breuken',
    module: 'Getalbegrip',
    description:
      'Leerling trekt ook de noemers van elkaar af (vaak resulterend in noemer 0), terwijl de noemer hetzelfde moet blijven.',
    typicalFamilies: ['GET-BREUK-GEL-MIN'],
  },
  {
    id: 'get.breuk-min-tweede-als-antwoord',
    label: 'Tweede breuk overgenomen als antwoord',
    module: 'Getalbegrip',
    description:
      'Leerling neemt de tweede breuk uit de som als antwoord in plaats van uit te rekenen.',
    typicalFamilies: ['GET-BREUK-GEL-MIN'],
  },
  {
    id: 'get.breuk-min-niet-vereenvoudigd',
    label: 'Antwoord niet vereenvoudigd',
    module: 'Getalbegrip',
    description:
      'Leerling laat het antwoord onvereenvoudigd staan terwijl de vraag expliciet om vereenvoudiging vraagt.',
    typicalFamilies: ['GET-BREUK-GEL-MIN', 'GET-BREUK-GEL-PLUS'],
  },
  {
    id: 'get.breuk-plus-noemers-optellen',
    label: 'Noemers opgeteld bij optellen van gelijknamige breuken',
    module: 'Getalbegrip',
    description:
      'Leerling telt de noemers op (bv. 4 + 4 = 8) bij het optellen van gelijknamige breuken, terwijl de noemer hetzelfde moet blijven.',
    typicalFamilies: ['GET-BREUK-GEL-PLUS'],
  },
  {
    id: 'get.breuk-plus-tellers-aftrekken',
    label: 'Tellers afgetrokken in plaats van opgeteld',
    module: 'Getalbegrip',
    description:
      'Leerling trekt de tellers van elkaar af in plaats van ze op te tellen.',
    typicalFamilies: ['GET-BREUK-GEL-PLUS'],
  },
  {
    id: 'get.breuk-gemengd-geheel-vergeten',
    label: 'Gehele deel niet meegerekend bij gemengde breuk',
    module: 'Getalbegrip',
    description:
      'Leerling vergeet het gehele deel van een gemengde breuk mee te nemen in de berekening.',
    typicalFamilies: ['GET-BREUK-GEMENGD'],
  },
  {
    id: 'get.breuk-gemengd-breuk-vergeten',
    label: 'Breukdeel niet meegerekend bij gemengde breuk',
    module: 'Getalbegrip',
    description:
      'Leerling neemt alleen het gehele deel mee en negeert het breukdeel.',
    typicalFamilies: ['GET-BREUK-GEMENGD'],
  },
  {
    id: 'get.breuk-gemengd-verwisseld',
    label: 'Teller en noemer verwisseld bij gemengde breuk',
    module: 'Getalbegrip',
    description:
      'Leerling verwisselt teller en noemer bij het omzetten van een gemengde breuk naar onechte breuk (of omgekeerd).',
    typicalFamilies: ['GET-BREUK-GEMENGD'],
  },
  {
    id: 'get.breuk-teller-misteld',
    label: 'Teller misteld op getallenlijn',
    module: 'Getalbegrip',
    description:
      'Leerling kiest het verkeerde streepje op de getallenlijn (off-by-one of willekeurig) en gebruikt dat als teller.',
    typicalFamilies: ['GET-BREUK-GETALLENLIJN'],
  },
  {
    id: 'get.breuk-noemer-als-teller',
    label: 'Noemer geïnterpreteerd als teller',
    module: 'Getalbegrip',
    description:
      'Leerling verwart teller en noemer en gebruikt het totaal aantal stukken als teller.',
    typicalFamilies: ['GET-BREUK-GETALLENLIJN'],
  },
  {
    id: 'get.breuk-noemer-uit-context-fout',
    label: 'Noemer onjuist uit getallenlijn afgelezen',
    module: 'Getalbegrip',
    description:
      'Leerling kiest de verkeerde noemer (verkeerd totaal aantal stukken) bij het aflezen van een breuk op een getallenlijn.',
    typicalFamilies: ['GET-BREUK-GETALLENLIJN'],
  },
  {
    id: 'get.breuk-onechte-niet-herkend',
    label: 'Onechte breuk niet herkend',
    module: 'Getalbegrip',
    description:
      'Leerling herkent niet dat een breuk waarbij teller groter is dan noemer een waarde groter dan 1 oplevert.',
    typicalFamilies: ['GET-BREUK-GETALLENLIJN'],
  },
  {
    id: 'get.breuk-gelijkwaardig-fout',
    label: 'Gelijkwaardige breuk fout berekend',
    module: 'Getalbegrip',
    description:
      'Leerling rekent de gelijkwaardige breuk verkeerd uit (bv. ½ ≠ ⁴⁄₈ verbinden via deling van noemer).',
    typicalFamilies: [
      'GET-BREUK-GETALLENLIJN',
      'GET-BREUK-GEL-PLUS',
      'GET-BREUK-GEL-MIN',
    ],
  },
  {
    id: 'get.breuk-vereenvoudig-fout',
    label: 'Breuk fout vereenvoudigd',
    module: 'Getalbegrip',
    description:
      'Leerling deelt teller en noemer door een verkeerd getal (of alleen teller óf alleen noemer) bij vereenvoudigen.',
    typicalFamilies: [
      'GET-BREUK-GETALLENLIJN',
      'GET-BREUK-GEL-PLUS',
      'GET-BREUK-GEL-MIN',
    ],
  },
  {
    id: 'get.breuk-uitbreiden-optellen-ipv-vermenigvuldigen',
    label: 'Teller en noemer opgeteld bij uitbreiden',
    module: 'Getalbegrip',
    description:
      'Leerling telt een getal op bij teller én noemer in plaats van beide te vermenigvuldigen bij het maken van een gelijkwaardige breuk.',
    typicalFamilies: [
      'GET-BREUK-GEL-PLUS',
      'GET-BREUK-GEL-MIN',
      'GET-BREUK-BASIS',
    ],
  },
  {
    id: 'get.breuk-alleen-noemer-aangepast',
    label: 'Alleen noemer aangepast bij uitbreiden',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt alleen de noemer (of alleen de teller) bij het uitbreiden van een breuk, waardoor de waarde verandert.',
    typicalFamilies: [
      'GET-BREUK-GEL-PLUS',
      'GET-BREUK-GEL-MIN',
      'GET-BREUK-BASIS',
    ],
  },
  {
    id: 'get.breuk-uitbreiden-vs-vereenvoudigen',
    label: 'Uitbreiden en vereenvoudigen verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling deelt teller en noemer in plaats van te vermenigvuldigen (of omgekeerd) bij het maken van een gelijkwaardige breuk.',
    typicalFamilies: [
      'GET-BREUK-GEL-PLUS',
      'GET-BREUK-GEL-MIN',
      'GET-BREUK-BASIS',
    ],
  },
  {
    id: 'get.breuk-referentie-deling-fout',
    label: 'Fout bij referentie-deling met breuken',
    module: 'Getalbegrip',
    description:
      'Leerling maakt een rekenfout bij het delen om met een referentiebreuk te vergelijken.',
    typicalFamilies: ['GET-BREUK-GEL-PLUS', 'GET-BREUK-GEL-MIN'],
  },
  {
    id: 'get.breuk-keer-gelijknamig-eerst',
    label: 'Gelijknamig maken vóór vermenigvuldigen',
    module: 'Getalbegrip',
    description:
      'Leerling maakt de breuken eerst gelijknamig en vermenigvuldigt dan, in plaats van direct teller × teller en noemer × noemer toe te passen.',
    typicalFamilies: ['GET-BREUK-KEER'],
  },
  {
    id: 'get.breuk-uitbreiden-factor-fout',
    label: 'Verkeerde factor bij uitbreiden',
    module: 'Getalbegrip',
    description:
      'Leerling gebruikt de verkeerde uitbreidingsfactor bij gelijknamig maken (bijv. ×3 i.p.v. ×4).',
    typicalFamilies: ['GET-BREUK-UITBREIDEN'],
  },
  {
    id: 'get.breuk-uitbreiden-teller-fout',
    label: 'Teller niet meegerekend bij uitbreiden',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt alleen de noemer en vergeet de teller met dezelfde factor te vermenigvuldigen.',
    typicalFamilies: ['GET-BREUK-UITBREIDEN'],
  },
  {
    id: 'get.breuk-uitbreiden-teller-niet-vermenigvuldigd',
    label: 'Teller helemaal niet vermenigvuldigd, alleen noemer aangepast',
    module: 'Getalbegrip',
    description:
      'Leerling laat de teller ongewijzigd staan (bijv. ¹⁄₁₈ bij ⅙ → ?/18) en past alleen de noemer aan. Verschilt van get.breuk-uitbreiden-teller-fout (waar de teller wél vermenigvuldigd wordt maar met een verkeerde factor).',
    typicalFamilies: ['GET-BREUK-UITBREIDEN'],
  },
  {
    id: 'get.breuk-noemers-optellen',
    label: 'Noemers opgeteld bij gelijknamig maken',
    module: 'Getalbegrip',
    description:
      'Leerling telt de noemers op om een gemeenschappelijke noemer te krijgen i.p.v. het kleinste gemene veelvoud te zoeken.',
    typicalFamilies: ['GET-BREUK-UITBREIDEN'],
  },
  {
    id: 'get.breuk-noemers-vermenigvuldigen-fout',
    label: 'Noemers altijd vermenigvuldigd',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt de noemers altijd met elkaar voor de nieuwe noemer, ook als kleiner kgv mogelijk is.',
    typicalFamilies: ['GET-BREUK-UITBREIDEN'],
  },
  {
    id: 'get.breuk-uitbreiden-niet-toegepast',
    label: 'Uitbreiden vergeten toegepast',
    module: 'Getalbegrip',
    description:
      'Leerling probeert breuken op te tellen zonder eerst gelijknamig te maken (uitbreiden weggelaten).',
    typicalFamilies: ['GET-BREUK-UITBREIDEN', 'GET-BREUK-GEL-PLUS'],
  },
]
